<template>
    <i class="i-ph-caret-right mt-0.5" />
    <account-link class="crumb truncate line-clamp-1" :account-no="accountNo">
        <i class="i-mdi-text-box mt-0.5" />
        {{ account?.accountNo }} {{ account?.name }}
    </account-link>
</template>

<script setup lang="ts">
import { findAccountByNo } from '@/bookkeeping-account/bookkeepingAccount.service'
import { computed } from 'vue'
import AccountLink from '@/bookkeeping-account/AccountLink.vue'

const props = defineProps({
    accountNo: {
        type: String,
        required: true
    }
})

const account = computed(() => {
    if (props.accountNo)
        return findAccountByNo(props.accountNo)
    return null
})

</script>

<style scoped></style>